import {formatCents} from '@/lib/format-utils'

/** A retailer's current/listed comparison is not historical price evidence. */
export function CurrentOfferDiscount({offer}:{offer:{priceCents?:number;originalCents?:number;isPriceUnknown?:boolean;isStale?:boolean}|null|undefined}){
 if(!offer||offer.isPriceUnknown||offer.isStale)return null
 const current=offer.priceCents,reference=offer.originalCents
 if(typeof current!=='number'||!Number.isSafeInteger(current)||current<=0||typeof reference!=='number'||!Number.isSafeInteger(reference)||reference<=current)return null
 const savings=reference-current
 if(savings<=5000)return null
 return <div data-testid="current-offer-discount" className="mb-3 p-3 rounded-lg bg-green-50 border border-green-200 flex items-center gap-3">
  <div className="flex-1">
   <div className="font-bold text-green-900 text-xs">Listed price savings</div>
   <div className="text-xs text-gray-700">{formatCents(savings)} below this retailer’s listed reference price</div>
  </div>
 </div>
}
